import * as React from 'react';
import { useCallback, useState } from 'react';
import { Field, Form } from 'formik';

import FormikForm from '~/lib/forms/FormikForm';
import Input from '~/common/controls/Input';
import Select from '~/common/controls/Select';

import { UserRole } from '~/apps/shared/consts';
import { UserShift } from "~/apps/pos/consts";
import ModelSelect from "~/common/controls/ModelSelect";


const ROLE_OPTIONS = [
  {
    label: 'Clerk',
    value: UserRole.CLERK,
  },
  {
    label: 'Agent',
    value: UserRole.AGENT,
  },
  {
    label: 'Warehouse manager',
    value: UserRole.WAREHOUSE_MANAGER,
  },
];

const forcePass = true;

type Errors = {
  username?: string,
  password?: string,
  role?: string,
  locationId?: string,
  departmentId?: string,
  shift?: string,
  firstName?: string,
  lastName?: string,
  forcePasswordChange?: boolean,
}

const UserCreateForm = (props) => {
  const { error, onSubmit, locations, locationHelper, currentUser: {locationId, role}, hasDepartmentFeature, departmentOptions, hasFHIFeature } = props;
  const [forcePassword, setForcePassword] = useState(forcePass);
  const initialValues = {
    username: '',
    password: '',
    role: UserRole.CLERK,
    locationId: role === UserRole.WAREHOUSE_MANAGER ? locationId: null,
    departmentId: null,
    shift: null,
    firstName: '',
    lastName: '',
    forcePasswordChange: forcePass,
  };

  const cbChangeForcePassword = (field, check) => {
    setForcePassword(!forcePassword);
  };

  const onSubmitForm = (data) => {
    if (onSubmit) onSubmit(data)
  };

  const validate = useCallback((values) => {
    const errors: Errors = {};

    if (!values.username) {
      errors.username = 'Required';
    }
    if (!values.password) {
      errors.password = 'Required';
    }
    if (!values.role) {
      errors.role = 'Required';
    }
    if (!values.locationId) {
      if (values.role === UserRole.WAREHOUSE_MANAGER) {
        errors.locationId = 'Required';
      }
    }
    if (hasDepartmentFeature && values.locationId) {
      if (!values.departmentId) {
        errors.departmentId = 'Required';
      }
    }
    if (!values.firstName) {
      errors.firstName = 'Required';
    }
    if (!values.lastName) {
      errors.lastName = 'Required';
    }
    return errors;
  }, [hasDepartmentFeature]);

  return (
    <FormikForm
      enableReinitialize={true}
      initialValues={initialValues}
      onSubmit={onSubmitForm}
      validate={validate}
      render={(props) => {
        const { setFieldValue, values: { locationId } } = props;

        const onLocationChange = (field, option) => {
          if (hasDepartmentFeature && field.value !== option.value) {
            setFieldValue('departmentId', null);
          }
        }

        const departmentOptionsByLocation = !hasDepartmentFeature || !locationId ? [] :
          departmentOptions.filter(dep => dep.locationId === locationId);

        return (
          <Form className="form__cont">
            <Field
              name="username"
              label="Username"
              type="text"
              component={Input}
              className="input input--bubble"
              autoComplete="off"
              value=""
            />
            <Field
              name="password"
              label="Password"
              type="password"
              component={Input}
              className="input input--bubble"
            />
            <Field
              name="role"
              label="Role"
              component={Select}
              options={ROLE_OPTIONS}
              className="input input--bubble input--bubble--withdrop"
            />
            {!!locations && <Field
              name="locationId"
              label="Location"
              component={Select}
              options={locations}
              className="input input--bubble"
              cbChange={onLocationChange}
            />}
            {!!locationHelper && <Field
              name="locationId"
              label="Location"
              placeholder="Location"
              component={ModelSelect}
              selectHelper={locationHelper}
              allowEmptyWithText={"- Without Location -"}
              className="input input--bubble"
              cbChange={onLocationChange}
            />}
            {hasDepartmentFeature && locationId &&
              <Field
                name="departmentId"
                label="Department"
                component={Select}
                options={departmentOptionsByLocation}
                className="input input--bubble"
              />
            }
            {hasFHIFeature &&
              <Field
                name="shift"
                label="Shift"
                component={Select}
                options={UserShift.selectOptions()}
                className="input input--bubble"
              />
            }
            <Field
              name="firstName"
              label="First Name"
              type="text"
              component={Input}
              className="input input--bubble"
            />
            <Field
              name="lastName"
              label="Last Name"
              type="text"
              component={Input}
              className="input input--bubble"
            />
            <div className="input--checkbox--inline">
              <Field
                name="forcePasswordChange"
                label="Force password change"
                className="input--checkbox"
                type="checkbox"
                cbChange={cbChangeForcePassword}
                checked={forcePassword}
                component={Input}
              />
            </div>

            {error && <div className="form__note">{error}</div>}

            <button className="btn btn--prim btn--lg" type="submit">
              Submit
            </button>
          </Form>
        );
      }}
    />
  );
};

export default UserCreateForm;
